import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Home from '@/components/Home'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login'),
      meta: {
        title: '登录',
        noCache: true,
      },
    },
    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      children: [
        {
          path: '/welcome',
          name: 'welcome',
          component: () => import('@/components/Welcome'),
          meta: {
            title: '主页',
            affix: true,
            noCache: true,
          },
        },
        {
          path: '/permits/users',
          name: 'users',
          component: () => import('@/views/users/Users'),
          meta: {
            title: '用户管理',
            noCache: true,
          },
        },
        {
          path: '/permits/roles',
          name: 'roles',
          component: () => import('@/views/roles/Roles'),
          meta: {
            title: '角色管理',
            noCache: true,
          },
        },
        {
          path: '/permits/permits',
          name: 'permits',
          component: () => import('@/views/permits/Permits'),
          meta: {
            title: '权限管理',
            noCache: true,
          },
        },
        {
          path: '/complaint',
          name: 'complaint',
          component: () => import('@/views/complaint/Complaint'),
          meta: {
            title: '投诉建议',
            noCache: true,
          },
        },
        {
          path: '/foodorder',
          name: 'foodorder',
          component: () => import('@/views/foodorder/foodorder'),
          meta: {
            title: '商品订单列表',
            noCache: true,
          },
        },
        {
          path: '/food-sales-report',
          name: 'food-sales-report',
          component: () => import('@/views/foodSales/FoodSalesReport'),
          meta: {
            title: '商品销售报表',
            noCache: true,
          },
        },
        {
          path: '/shop-dine-qrcode',
          name: 'shop-dine-qrcode',
          component: () => import('@/views/shopDine/ShopDineQrcodeManage'),
          meta: {
            title: '堂食桌码',
            noCache: true,
          },
        },
        {
          path: '/merchant-alert',
          name: 'merchant-alert',
          component: () => import('@/views/merchantAlert/MerchantAlertSettings'),
          meta: {
            title: '点餐提醒音',
            noCache: true,
          },
        },
        {
          path: '/coupon-manage',
          name: 'coupon-manage',
          component: () => import('@/views/coupon/CouponManage'),
          meta: {
            title: '优惠券管理',
            noCache: true,
          },
        },
        {
          path: '/coupon-issued',
          name: 'coupon-issued',
          component: () => import('@/views/coupon/CouponIssued'),
          meta: {
            title: '已发放优惠券',
            noCache: true,
          },
        },
        {
          path: '/stored-value',
          name: 'stored-value',
          component: () => import('@/views/storedValue/StoredValue'),
          meta: {
            title: '储值活动',
            noCache: true,
          },
        },
        {
          path: '/stored-value-ledgers',
          name: 'stored-value-ledgers',
          component: () => import('@/views/storedValue/StoredValueLedgers'),
          meta: {
            title: '充值记录',
            noCache: true,
          },
        },
        {
          path: '/benefit-cards',
          name: 'benefit-cards',
          component: () => import('@/views/member/BenefitCards'),
          meta: {
            title: '权益卡',
            noCache: true,
          },
        },
        {
          path: '/member-benefits',
          name: 'member-benefits',
          component: () => import('@/views/member/MemberBenefits'),
          meta: {
            title: '会员权益',
            noCache: true,
          },
        },
        {
          path: '/customer',
          name: 'customer',
          component: () => import('@/views/customer/Customer'),
          meta: {
            title: '用户列表',
            noCache: true,
          },
        },
        {
          path: '/customer/detail/:id',
          name: 'customer-detail',
          component: () => import('@/views/customer/CustomerDetail'),
          meta: {
            title: '用户详情',
            noCache: true,
          },
        },
        {
          path: '/logs/operation',
          name: 'operation-log',
          component: () => import('@/views/logs/OperationLog'),
          meta: {
            title: '操作日志',
            noCache: true,
          },
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: () => import('@/views/notifications/MessageCenter'),
          meta: {
            title: '消息中心',
            noCache: true,
          },
        },
        {
          path: '/monitor',
          name: 'monitor',
          component: () => import('@/views/monitor/SystemMonitor'),
          meta: {
            title: '系统监控',
            noCache: true,
          },
        },
        {
          path: '/goods',
          name: 'goods',
          component: () => import('@/views/goods/Goods'),
          meta: {
            title: '商品管理',
            noCache: true,
          },
        },
        {
          path: '/food-type',
          name: 'food-type',
          component: () => import('@/views/foodType/FoodType'),
          meta: {
            title: '商品分类',
            noCache: true,
          },
        },
        {
          path: '/other',
          name: 'other',
          component: () => import('@/views/others/Other'),
          meta: {
            title: '客服管理',
            noCache: true,
          },
        },
        {
          path: '/lang',
          name: 'lang',
          component: () => import('@/views/langs/Lang'),
          meta: {
            title: '国际化管理',
            noCache: true,
          },
        },
      ],
    },
    { path: '*', name: '*', component: () => import('@/components/404') },
  ],
})
const LOGIN_PAGE_NAME = 'login'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  const token = store.getters.token
  if (!token && to.name != LOGIN_PAGE_NAME) {
    next({ name: LOGIN_PAGE_NAME })
  } else {
    next()
  }
})

export default router
